// extracted by mini-css-extract-plugin
export var box = "box-module--box--1s4an";
export var hoverBox = "box-module--hoverBox--laPDE";
export var vizBox = "box-module--vizBox--2CVFK";